import React from 'react';
import './categoryTitleBox.scss';

const CategoryTitleBox = ({arrow, title, theme}) => {
  return (
    <div className='title-arrow'>
      <span className={`title-arrow__pill title-arrow__pill_${theme}`}>{title}</span>
      <img src={arrow} alt="" loading="lazy"/>
    </div>
  )
}

export default CategoryTitleBox